import React from 'react';
import { Box } from '@common-fe/common-fe';

import PERMISSIONS from '@/common/permissions';
import ROUTES from '@/common/routes';
import { useHasAccess } from '@/modules/core';
import Topbar from '@/modules/core/components/Topbar';
import { useBreadcrumbs } from '@/modules/core/hooks/useBreadcrumbs';
import { ReplenishmentInvoiceReportDetails } from '@/modules/Reports/ReportDetails';

const ReplenishmentInvoiceReportPage = () => {
  useBreadcrumbs([
    {
      route: ROUTES.NEW_REPORTS,
      title: 'Reports',
    },
    {
      route: ROUTES.REPLENISHMENT_INVOICE_REPORT,
      title: 'Replenishment Invoice',
    },
  ]);
  const isHasPermission = useHasAccess([
    {
      permission: PERMISSIONS.REPORTS,
    },
  ]);
  if (!isHasPermission) {
    return null;
  }

  return (
    <Box width="100%" data-testid="topbar-wrapper">
      <div>
        <Topbar />
      </div>
      <Box>
        <Box margin={{ top: 'spacing24' }}>
          <ReplenishmentInvoiceReportDetails />
        </Box>
      </Box>
    </Box>
  );
};

export default ReplenishmentInvoiceReportPage;
